export enum OWNER_TYPE {
  ThirdParty = "third party",
  Member = "member",
  MyOrganization = "my organization",
  Collaboration = "collaboration",
}
